import { take, takeLatest } from "redux-saga/effects";

import { Action } from "../../App/ScormPackageManagement/actions";
import * as actions from "../../App/ScormPackageManagement/actions";
import * as sagas from "../../App/ScormPackageManagement/actions/sagas";

export function* watchMount() {
  yield takeLatest(
    Action.MOUNT,
    sagas.fetchInitialData({
      onFailure: actions.handleFetchInitialDataFailure,
      onSuccess: actions.handleFetchInitialDataSuccess,
    })
  );
}

export function* watchUnmount() {
  yield take(Action.UNMOUNT);
}

export function* watchPatchScormPackage() {
  yield takeLatest(
    Action.PATCH_SCORM_PACKAGE,
    sagas.patchScormPackage({
      onFailure: actions.handlePatchScormPackageFailure,
      onSuccess: actions.handlePatchScormPackageSuccess,
      refreshScormPackage: {
        onFailure: actions.handleRefreshScormPackageFailure,
        onSuccess: actions.handleRefreshScormPackageSuccess,
      },
    })
  );
}
